module.exports = __webpack_public_path__ + "static/csharp-b34f8e6801d3cae6f6b3f553040aa018.jpg";